import { mockServerForwardHandler, aceFetchFallback } from './wrappers';
import { composeWrappers } from './utils';

export const getExtendedFetchFn = state => {
  const wrappers = [aceFetchFallback, mockServerForwardHandler];

  return composeWrappers(wrappers, state);
};
